import React from "react"
import SignUpSteps from "../../../components/KYCComponents/component/SignUpSteps"

const OnBoardingLeftContainer = ({
  onBoardingStep = 2,
  totalSteps,
  step,
  description,
  title,
  title2,
  onBoardingSteps,
}) => {
  return (
    <div className="flexCol flex-1 justify-between">
      <div className="flex flex-col">
        <div className="flexRow justify-between">
          <p className="font-filson-soft font-[700] text-[32px] leading-[40px]">
            {title}
            {title2 ? ( // TODO:: To be removed 
              <>
                <br />
                {title2}
              </>
            ) : null}
          </p>
          {totalSteps ? (
            <span className="font-Apparat font-[700] text-[16px] leading-[17.6px] text-[#424952D9] mt-[7px] ml-[20px]">
              {step}/{totalSteps}
            </span>
          ) : null}
        </div>

        <p className="font-Apparat text-[#424952D9] text-[14px] leading-[22px] font-[400] mt-[16px]">
          {description}
        </p>
      </div>
      <SignUpSteps
        activeStep={onBoardingStep}
        onBoardingSteps={onBoardingSteps}
      />
    </div>
  )
}

export default OnBoardingLeftContainer
